var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgButtonMagnifier = function SvgButtonMagnifier(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11.89 11.91",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "button_magnifier")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.87,9.77a4.89,4.89,0,1,1,4.9-4.85A4.88,4.88,0,0,1,4.87,9.77Zm0-8.07A3.19,3.19,0,1,0,8.07,4.9,3.2,3.2,0,0,0,4.88,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.38,8.46a2.27,2.27,0,0,1,.57.32c.57.54,1.12,1.1,1.66,1.65a.85.85,0,1,1-1.19,1.2c-.57-.56-1.13-1.13-1.69-1.7A.79.79,0,0,1,8.57,9a.81.81,0,0,1,.77-.5Z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgButtonMagnifier, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/button_magnifier.776ad62f.svg";
export { ForwardRef as ReactComponent };